import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { ScaleWidgetComponent } from './components/scale-widget/scale-widget.component';
import { SliderWidgetComponent } from './components/slider-widget/slider-widget.component';
import { SharedLibraryModule } from '../common/shared-library.module';
import { QuestionAnswerOptionCodeComponent } from './components/question-answer-option-code/question-answer-option-code.component';
import { QuestionHintComponent } from './components/question-hint/question-hint.component';
import { QuestionOptionComponent } from './components/question-option/question-option.component';
import { QuestionAnswerValidationIndicatorComponent } from './components/question-answer-validation-indicator/question-answer-validation-indicator.component';
import { ButtonWidgetComponent } from './components/button-widget/button-widget.component';
import { ChallengesWidgetComponent } from './components/challenges-widget/challenges-widget.component';
import { LearningPathsWidgetComponent } from './components/learning-paths-widget/learning-paths-widget.component';
import { LearningPathCardModule } from '../learning-path-card/learning-path-card.module';
import { ContentHighlightWidgetComponent } from './components/content-highlight-widget/content-highlight-widget.component';
import { ContentCardModule } from '../content-card/content-card.module';
import { CarouselWidgetComponent } from './components/carousel-widget/carousel-widget.component';
import { NgScrollbar } from 'ngx-scrollbar';
import { InstaLearnPostsWidgetComponent } from './components/insta-learn-posts-widget/insta-learn-posts-widget.component';
import { InstaCardsDialogComponent } from './components/insta-cards-dialog/insta-cards-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { InstaLearnTopicsWidgetComponent } from './components/insta-learn-topics-widget/insta-learn-topics-widget.component';
import { InstaLearnPostsDialogService } from './services';
import { InstaTopicsDialogComponent } from './components/insta-topics-dialog/insta-topics-dialog.component';
import { InstaTopicCardComponent } from './components/insta-topic-card/insta-topic-card.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AccordionWidgetComponent, HotspotMarkerComponent, QuestionMatchingComponent, QuestionSortingWidgetComponent } from './components';
import { HotspotContentComponent } from './components/hotspots-widget/hotspot-content/hotspot-content.component';
import { HotspotsWidgetComponent } from './components/hotspots-widget/hotspots-widget.component';
import { MatMenuModule } from '@angular/material/menu';
import { BucketsWidgetComponent } from './components/buckets-widget/buckets-widget.component';
import { BucketCardComponent } from './components/buckets-widget/bucket-card/bucket-card.component';
import { SlideBackgroundContextDirective } from './directives';


@NgModule({
  declarations: [
    SliderWidgetComponent,
    ScaleWidgetComponent,
    QuestionAnswerOptionCodeComponent,
    QuestionHintComponent,
    QuestionOptionComponent,
    QuestionAnswerValidationIndicatorComponent,
    HotspotMarkerComponent,
    ButtonWidgetComponent,
    ChallengesWidgetComponent,
    LearningPathsWidgetComponent,
    ContentHighlightWidgetComponent,
    CarouselWidgetComponent,
    InstaLearnPostsWidgetComponent,
    InstaCardsDialogComponent,
    InstaLearnTopicsWidgetComponent,
    InstaTopicsDialogComponent,
    InstaTopicCardComponent,
    AccordionWidgetComponent,
    QuestionMatchingComponent,
    HotspotContentComponent,
    HotspotsWidgetComponent,
    BucketsWidgetComponent,
    BucketCardComponent,
    SlideBackgroundContextDirective,
    QuestionSortingWidgetComponent
  ],
  exports: [
    SliderWidgetComponent,
    ScaleWidgetComponent,
    QuestionAnswerOptionCodeComponent,
    QuestionHintComponent,
    QuestionOptionComponent,
    QuestionAnswerValidationIndicatorComponent,
    HotspotMarkerComponent,
    ButtonWidgetComponent,
    ChallengesWidgetComponent,
    LearningPathsWidgetComponent,
    ContentHighlightWidgetComponent,
    CarouselWidgetComponent,
    InstaLearnPostsWidgetComponent,
    InstaCardsDialogComponent,
    InstaLearnTopicsWidgetComponent,
    InstaTopicsDialogComponent,
    InstaTopicCardComponent,
    AccordionWidgetComponent,
    QuestionMatchingComponent,
    HotspotContentComponent,
    HotspotsWidgetComponent,
    BucketsWidgetComponent,
    BucketCardComponent,
    SlideBackgroundContextDirective,
    QuestionSortingWidgetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatRadioModule,
    MatDialogModule,
    MatExpansionModule,
    MatMenuModule,
    DragDropModule,
    SharedLibraryModule,
    LearningPathCardModule,
    ContentCardModule,
    NgScrollbar
  ],
  providers: [
    InstaLearnPostsDialogService
  ]
})
export class ChaptersWidgetsModule {
}
